
  export default theme => ({
  
    tabInnerContent: {
      padding: theme.spacing(3),
      paddingBottom: 120,
    },
    levelContainer: {
      marginTop: 5
    },
    contentTitle:{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: theme.spacing(3),
      borderBottom: `1px solid ${theme.palette.background.light}`
    },
    tabContentActions: {
      width: "100%",
      position: "absolute",
      bottom: 0,
      left: 0,
      borderTop: `1px solid ${theme.palette.background.light}`,
      padding: theme.spacing(3)
    }
 
  
  })